import React from "react"

const Media = () => (
  <>
    <iframe
      className="video"
      title="Synchronicity II cover"
      src="https://www.youtube.com/embed/3s1hSQW0XUI?si=K24h-aHzVnUX1JeO"
      frameborder="0"
      // allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allow=""
      allowfullscreen
    ></iframe>
    <iframe
      className="video"
      title="See My Future"
      src="https://www.youtube.com/embed/nYIjE-8TCEQ?si=d6eKYe-Am_L5yAsm"
      frameborder="0"
      // allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allow=""
      allowfullscreen
    ></iframe>
    <iframe
      className="video"
      width="560"
      height="315"
      src="https://www.youtube.com/embed/D1Q_G1FA5nQ?si=lOFLqrxYqGgSygLw"
      title="No Regrets"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
    <h4 className="more">
      For more video visit us on{" "}
      <a
        href="https://www.youtube.com/@east-of-friday"
        target="_blank"
        rel="noreferrer"
      >
        youTube @east-of-friday
      </a>
    </h4>
  </>
)

export default Media
